import { parse } from "querystring";
import { pathToRegexp } from "path-to-regexp";

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
export const isUrl = (path) => reg.test(path);

export const getPageQuery = () => parse(window.location.href.split("?")[1]);
/**
 * props.route.routes
 * @param router [{}]
 * @param pathname string
 */

export const getAuthorityFromRouter = (router = [], pathname) => {
	const authority = router.find(({ path }) => path && pathToRegexp(path).exec(pathname));
	if (authority) return authority;
	return undefined;
};
export const getRouteAuthority = (path, routeData) => {
	let authorities;
	routeData.forEach((route) => {
		// match prefix
		if (pathToRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
			if (route.authority) {
				authorities = route.authority;
			} // exact match

			if (route.path === path) {
				authorities = route.authority || authorities;
			} // get children authority recursively

			if (route.routes) {
				authorities = getRouteAuthority(path, route.routes) || authorities;
			}
		}
	});
	return authorities;
};
